/**
 * tandem · kit page (blocks/t-kit-contents.liquid)
 *
 * Each product of the kit has its own options. Choosing one finds the matching variant, shows
 * its photo and price, and writes it in the kit form, which t-cart.js adds to the cart in one go.
 * A combination that is sold out keeps the button disabled.
 */

function variantsOf(item) {
  try {
    return JSON.parse(item.querySelector('[data-t-kit-variants]')?.textContent || '[]');
  } catch {
    return [];
  }
}

function initKit(kit) {
  if (kit.dataset.tKitBound) return;
  kit.dataset.tKitBound = 'true';
  const form = kit.querySelector('[data-t-kit-form]');
  const button = form?.querySelector('[data-t-kit-add]');
  if (!form || !button) return;
  const addLabel = button.textContent;
  const items = [...kit.querySelectorAll('[data-t-kit-item]')];
  const state = new Map();

  const refreshButton = () => {
    const soldOut = [...state.values()].some((variant) => variant && !variant.available);
    const missing = [...state.values()].some((variant) => !variant);
    button.disabled = soldOut || missing;
    button.textContent = soldOut ? button.dataset.labelSoldOut || addLabel : addLabel;
  };

  const choose = (item) => {
    const variants = variantsOf(item);
    if (!variants.length) return;
    const picked = [...item.querySelectorAll('[data-t-kit-option]:checked')]
      .sort((a, b) => Number(a.dataset.tKitOption) - Number(b.dataset.tKitOption))
      .map((input) => input.value);
    const variant = variants.find((candidate) => candidate.options.every((value, index) => value === picked[index])) || null;
    state.set(item, variant);

    item.querySelectorAll('[data-t-kit-option]').forEach((input) => {
      if (!input.checked) return;
      const chosen = input.closest('fieldset')?.querySelector('[data-t-kit-chosen]');
      if (chosen) chosen.textContent = input.value;
    });
    // Values that would lead to a sold out variant, given the other choices
    item.querySelectorAll('[data-t-kit-option]').forEach((input) => {
      const index = Number(input.dataset.tKitOption);
      const options = picked.slice();
      options[index] = input.value;
      const match = variants.find((candidate) => candidate.options.every((value, i) => value === options[i]));
      input.closest('.t-kit__value')?.classList.toggle('is-unavailable', !match || !match.available);
    });

    if (variant) {
      const field = form.querySelector(`[data-t-kit-variant="${item.dataset.tKitItem}"]`);
      if (field) field.value = String(variant.id);
      const each = item.querySelector('[data-t-kit-each]');
      if (each && variant.each) each.textContent = variant.each;
      const image = item.querySelector('[data-t-kit-media] img');
      if (image && variant.image) {
        image.removeAttribute('srcset');
        image.src = variant.image;
      }
    }
    refreshButton();
  };

  for (const item of items) {
    if (!item.querySelector('[data-t-kit-variants]')) continue;
    item.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches('[data-t-kit-option]')) choose(item);
    });
    choose(item);
  }
}

document.querySelectorAll('[data-t-kit]').forEach(initKit);
// The theme editor re-renders blocks: bind the new ones
document.addEventListener('shopify:block:select', () => document.querySelectorAll('[data-t-kit]').forEach(initKit));
document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-t-kit]').forEach(initKit));
